import { useEffect, useState } from "react";
import { Building } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export const BranchSwitcher = () => {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const current = localStorage.getItem("branch");

  useEffect(() => {
    api.get("/branches").then(({ data }) => {
      setBranches(data);
      if (user.role === "admin" && !data.some((b) => b.id === current) && data[0]) {
        localStorage.setItem("branch", data[0].id);
        window.location.reload();
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (user.role !== "admin") {
    const mine = branches.find((b) => b.id === user.branch_id);
    return mine ? <span className="text-sm font-bold text-[#3E3E40] flex items-center gap-1" data-testid="current-branch"><Building className="w-4 h-4" />{mine.name}</span> : null;
  }
  return (
    <label className="flex items-center gap-1 text-sm font-bold text-[#3E3E40]">
      <Building className="w-4 h-4" />
      <select data-testid="branch-switcher" className="h-9 border rounded-md px-2 bg-white text-sm font-bold" value={current || ""}
        onChange={(e) => { localStorage.setItem("branch", e.target.value); window.location.reload(); }}>
        {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      </select>
    </label>
  );
};
